import React, {FC} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@material-ui/core";
import {FeOrder, WorkerDay} from "../../orders/redux/types";
import {Calendar} from "@material-ui/pickers";
import {isToday} from "date-fns";
import {useWorkerCalendarDays} from "../../orders/redux/orders.hook";
import {AuthContext} from "../../../auth/components/AuthProvider";
import {formatDate} from "../../../date.utils";
import {makeStyles} from "@material-ui/core/styles";
import {MaterialUiPickersDate} from "@material-ui/pickers/typings/date";
import clsx from "clsx";
import {CalendarDayDialog} from "../../workers/screens/worker/CalendarDayDialog";

const useDayStyles = makeStyles((theme) => ({
    day: {
        width: "36px",
        height: "36px",
        fontSize: "0.95rem",
        margin: "0 2px",
        padding: 0,
        color: "inherit",
        fontWeight: 500,
        flex: "auto",
        overflow: "visible",
        textAlign: "center"
    },
    today: {
        color: theme.palette.error.main
    },
    hasOrder: {
        backgroundColor: theme.palette.warning.light
    },
    hasAvailability: {
        backgroundColor: theme.palette.primary.main
    }
}));

interface NextAppointmentDayProps {
    date: MaterialUiPickersDate;
    disabled?: boolean;
    toggleDialog: () => void;
    today?: boolean;
    workerDay?: WorkerDay;
    workerId: string;
    oldOrder: FeOrder;
}

const NextAppointmentDay: FC<NextAppointmentDayProps> = (props) => {
    const classes = useDayStyles();

    const [showDialog, setShowDialog] = React.useState(false);

    const filteredOrders = props.workerDay?.orders.filter(o => o.confirmed && !o.cancellation);

    const buttonClasses = clsx(
        classes.day,
        props.today && classes.today,
        filteredOrders && filteredOrders.length > 0 ? classes.hasOrder : props.workerDay?.availability && classes.hasAvailability
    );

    return (
        <div role="presentation">
            {props.workerDay && props.date &&
            <CalendarDayDialog
                dayDate={props.date}
                toggleDialog={() => {
                    setShowDialog(p => !p);
                    props.toggleDialog();
                }}
                open={showDialog}
                oldOrder={props.oldOrder}
                workerDay={props.workerDay}
                withNextAppointmentButton
            />}
            <IconButton
                disabled={props.disabled}
                className={buttonClasses}
                onClick={() => {
                    if (!props.disabled && props.workerDay?.availability) {
                        setShowDialog(true);
                    }
                }}
            >
                <span>{formatDate(props.date, "d")}</span>
            </IconButton>
        </div>
    );
}

interface NextAppointmentDialogProps {
    open: boolean;
    toggleDialog: () => void;
    oldOrder: FeOrder;
}

export const NextAppointmentDialog: FC<NextAppointmentDialogProps> = (props) => {

    const today = new Date();
    const {userId} = React.useContext(AuthContext);
    const [selectedDate] = React.useState(today);
    const [selectedMonth, setSelectedMonth] = React.useState<Date>(new Date());

    const {
        workerDays
    } = useWorkerCalendarDays(userId ?? "", selectedMonth);

    return (
        <Dialog open={props.open} onClose={props.toggleDialog}>
            <DialogTitle>Folgetermin Vereinbaren</DialogTitle>
            <DialogContent>
                <Calendar
                    date={selectedDate}
                    onMonthChange={month => {
                        if (month) {
                            setSelectedMonth(month);
                        }
                    }}
                    onChange={() => {
                    }}
                    renderDay={(day, selectedDate, dayInCurrentMonth) => (
                        day
                            ? <NextAppointmentDay
                                workerId={userId ?? ""}
                                workerDay={workerDays[day.getDate() - 1]}
                                date={day}
                                oldOrder={props.oldOrder}
                                disabled={!dayInCurrentMonth}
                                toggleDialog={props.toggleDialog}
                                today={Boolean(day && isToday(day.getTime()))}
                            />
                            : <React.Fragment/>
                    )}
                />
            </DialogContent>
            <DialogActions style={{marginTop: 16}}>
                <Button onClick={props.toggleDialog}>Abbrechen</Button>
                <Button
                    color="primary"
                    // onClick={handleCreateNewAppointment}
                >
                    Termin Buchen
                </Button>
            </DialogActions>
        </Dialog>
    )
}
